import React from 'react';

import State from '~components/ProjectState';

import styles from '../../styles.module.scss';
import { renderSubtitle } from '../../utils';

interface Props {
  stageOrder: number;
}

function StateContent({ stageOrder }: Props) {
  const subtitleDisplay = renderSubtitle('status');
  const valueDisplay = <State smallSize actualStageOrder={stageOrder} />;

  return (
    <div key={subtitleDisplay} className={styles.dropdown}>
      <h2 className={`paratext ${styles.subtitle}`}>{subtitleDisplay}</h2>
      <div className="m-left-6">{valueDisplay}</div>
    </div>
  );
}

export default StateContent;
